<template>
  <div class="bigBox">
    <div style="width: 100%; background-color: #222222">
      <div class="videoBar">
        <div v-if="courseDetail && courseDetail.liveCourseStatus != 1" class="videoBox">
          <div class="leftVideo">
            <div class="titleBox">
              <div class="tag tagBack">回放中</div>
              <div class="title">{{ courseDetail.openCourseName }}</div>
              <div class="time">直播时间：{{ courseDetail.liveStartTime }}</div>
            </div>
            <div class="video">
              <div style="height: 675px; width: 1200px; margin: 0 auto" v-if="courseDetail.playbackLink">
                <jxyplayer :url="courseDetail.playbackLink" :options="option" />
              </div>
              <div v-else class="mainvideos">
                <div id="playbackPanel"></div>
                <div id="playbackPlayer"></div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="courseDetail && courseDetail.liveCourseStatus == 1" class="mainvideo">
          <div id="drawPanel" style="
              width: 100%;
              height: 675px;
              background-color: #ffffff;
              position: relative;
            "></div>
          <div style="margin-left: 10px">
            <div id="livePlayer" style="
                width: 300px;
                height: 200px;
                position: relative;
                border-radius: 10px;
              "></div>
            <div v-if="courseDetail && courseDetail.liveCourseStatus == 1" class="NIM_wrap">
              <div class="title">讨论区</div>
              <div id="msgBlock" class="information">
                <div v-for="(item, index) in list" :key="index" class="white">
                  <div class="wrap" :class="item.userid == userInfo.userId
                      ? 'dis-end'
                      : 'dis-start'
                    ">
                    <div class="formNick">{{ item.username }}</div>
                    <div class="text">{{ item.msg }}</div>
                  </div>
                  <div style="clear: both" />
                </div>
              </div>
              <div class="barrageInput">
                <el-input v-model="barrage" class="input" placeholder="请输入"
                  onkeydown="if (event.keyCode===13){return false;}" @keyup.enter.native="sendMessage" />
                <el-button size="mini" type="primary" class="sendBtn" @click="sendMessage">发送</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div class="recommend">
      <div class="recommendText">相关推荐</div>
      <div class="itemBox">
        <div v-for="item in recommendList" :key="item.id" @click="toDetail(item)">
          <div   class="recommendItem">
            <img class="imgItem" :src="item.surfacePlot" />
            <div class="textItem">
              <div class="courseName twoEllipsis">{{ item.openCourseName }}</div>
              <div class="playNum">
                <img class="symbol" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/Frame.png" />
                <span class="num">{{ item.heatDegree ? item.heatDegree : 0 }}次播放</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { getInfo } from "@/api/cookies";
import jxyplayer from "@/components/jxyPlay.vue";

import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: {
    jxyplayer,
  },
  data() {
    return {
      id: null, // 公开课主键ID
      courseDetail: {},
      recommendList: [],
      recommendedLive: [],
      userInfo: null,
      zbStartTime: null,
      imQunId: null,
      barrage: "", // 输入框
      list: [],
      im_websocket: "",
      ws_server_url: "",
      im_time_interval: "",
      count: 0,
      stuId: "", // 观看学生用户id
      tenantId: "", // 机构id
      userId: "", // 邀请人用户id'
      status: "", // 1 学生分享  2老师分享 0 主动进去
      time: 0,
      timer: null,
      timers: null,
      shareShow: false,
      QRCodeUrl: "",
      PCtext: "",
      test1: null,
      player: null,
      currentVideo: {},
      wssresult: "",
      nickName: "",
      option: {
        width: "100%",
        height: "100%",
        type: "HLS",
        aDType: "swiper",
      },
    };
  },
  async created() {
    this.userInfo = await getInfo();
    this.id = this.$route.query.id;
  },
  async mounted() {
    this.userInfo = await getInfo();
    if (this.userInfo) {
      this.id = this.$route.query.id;
      this.getDetail();
      this.getRecommend();
    } else {
      Vue.prototype.goLoginView(true);
    }
  },

  methods: {
       toDetail(item) {
      if (this.userInfo) {
        if (item.liveCourseStatus == 0) {
          this.$message({
            type: 'error',
            message: '直播未开始'
          })
          return
        }
        if (item.liveCourseStatus == 2 && !item.playbackLink) {
          this.$message({
            type: 'error',
            message: '回放生成中'
          })
        }  else {
          this.addRecord(item)
          const routeUrl = this.$router.resolve({
            path: '/publicClass/publicClassDetail',
            query: {
              id: item.openCourseId,
            },
          })
          window.open(routeUrl.href, '_blank')
        }
      } else {
        Bus.$emit('toLoginPage', true)
      }
    },
     addRecord(item) {
      const data = {
        openCourseId: item.openCourseId,
      }
      homeClient.addBrowseJxyFrequency(data).then((res) => { })
    },
    getRecommend() {
      const data = {
        pageNum: 1,
        pageSize: 10,
      };
      homeClient.queryOpenRecommend(data).then((res) => {
        if (res.code == 0) {
          this.recommendList = res.data.rows;
        }
      });
    },
    getDetail() {
      const data = {
        openCourseId: this.id,
      };
      homeClient.queryOpenCourseBeyId(data).then((res) => {
        if (res.code === 0) {
          this.courseDetail = res.data;
          if (this.courseDetail.liveCourseStatus == 1) {
            setTimeout(() => {
              this.initCCZBPlayer();
            }, 1000);
          } else {
            if (this.courseDetail.playbackLink) {
            } else {
              this.initCCPlayer();
            }
          }
        }
      });
    },

    initCCZBPlayer() {
      let that = this;
      console.log(DWLive, "DWLive");
      const query = this.getUrlParams(this.courseDetail.playLink);

      const roomId = query.roomid;
      const nickName =
        that.userInfo.wxStuId +
        "-" +
        (that.userInfo.nickName || that.userInfo.wxNickName);

      DWLive.init({
        userid: "41A331E332E32281", //必须参数
        roomid: roomId, //必须参数
        pcH5Live: true,
        viewername: nickName,
        viewertoken: "123",
      });

      // 接收公聊
      DWLive.onPublicChatMessage = function (j) {
        const msgObg = JSON.parse(j);
        console.log(msgObg, "msgObg");

        that.list = that.list.concat(msgObg);
        // 滚动到底部
        that.$nextTick(function () {
          const msgBlock = document.getElementById("msgBlock");
          msgBlock.scrollTo({
            // 滚动动画
            top: msgBlock.scrollHeight,
            behavior: "smooth",
          });
        });
      };
    },
    getUrlParams(urlStr) {
      if (typeof urlStr == "undefined") {
        // 获取url中"?"符后的字符串
        var url = decodeURI(location.search);
      } else {
        var url = "?" + urlStr.split("?")[1];
      }
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substring(1);
        let strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    },
    /* 初始化CC播放器 */
    initCCPlayer() {
      setTimeout(() => {
        this.initCSSPlaybackPlayer();
      }, 100);
    },
    /* 初始化CC直播回放播放器 */
    initCSSPlaybackPlayer() {
      const recordId = this.courseDetail?.ccPlaybackId || "";
      const roomId = this.courseDetail?.liveRootId || "";
      let that = this;
      $.DW.config({
        userId: "41A331E332E32281",
        roomId: roomId, //直播间Id
        recordId: recordId, //直播回放Id
        isH5play: true,
        fastMode: true,
      });
    },
    // 发送聊天
    sendMessage() {
      if (this.barrage == "") {
        this.$message.error("请输入内容！");
      } else {
        DWLive.sendPublicChatMsg(this.barrage); // 发送公聊
        this.barrage = "";
      }
    },
    // 初始化聊天
    initPublicChat() { },

    scrollbottom() {
      this.$nextTick(() => {
        const msgBlock = document.getElementById("msgBlock");
        msgBlock.scrollTop = msgBlock.scrollHeight;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bigBox {
  width: 100%;
  overflow: hidden;
  position: relative;

  // margin: 0 auto;
  .share_box {
    position: absolute;
    top: 30%;
    z-index: 9999999;

    .share_btn {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      width: 40px;
      height: 83px;
      border-radius: 0 8px 8px 0;
      background-color: #ffffff;
      cursor: pointer;
      border: 1px solid #006cff;
      color: #006cff;
    }

    .share {
      width: 300px;
      height: 300px;
      border-radius: 8px;
      background-color: #ffffff;
      position: absolute;
      top: 0;
      right: -305px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .QRCode {
        width: 150px;
        height: 150px;
      }

      .PCtext {
        margin-top: 10px;
        width: 250px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #333333;
      }
    }
  }

  .aliVideoBar {
    width: 100%;
    height: 617px !important;
    background-color: #222222;
    padding: 32px 0;
    margin-bottom: 20px;
  }

  .videoBar {
    width: 1200px;
    margin: 0 auto;
    height: 90vh;
    max-height: 740px;
    background-color: #222222;
    padding: 32px 0;
    // margin-bottom: 20px;
    position: relative;

    .videoWrap {
      border: none;
      width: 1220px !important;
      height: 553px !important;
      margin: auto !important;
      display: flex;
    }

    video {
      width: 100%;
      height: 100%;
    }

    .videoBox {
      border: none;
      width: 100%;
      height: 100%;
      margin-top: -32px;
      display: flex;
      overflow: hidden;

      .leftVideo {
        width: 100%;
        height: 553px;
        margin-right: 20px;

        .titleBox {
          height: 58px;
          border-radius: 8px 8px 0 0;
          background-color: #383838;
          padding: 19px 20px;
          color: #ffffff;
          display: flex;
          align-items: center;

          .title {
            flex: 1;
            font-size: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-right: 50px;
          }

          .time {
            font-size: 14px;
          }
        }

        .video {
          width: 100%;
          // height: 495px;
          border-radius: 0 0 8px 8px;
        }
      }

      .rightBox {
        width: 320px;
        height: 553px;

        .topTitle {
          height: 48px;
          background-color: #444444;
          border-radius: 8px 8px 0 0;
          line-height: 48px;
          color: #ffffff;
          padding-left: 21px;
        }

        .contentList {
          background-color: #383838;
          padding: 20px;
          height: 505px;
          border-radius: 0 0 8px 8px;

          .contentItem {
            height: 76px;
            width: 273px;
            display: flex;
            margin-bottom: 20px;

            .itemImg {
              width: 114px;
              height: 76px;
              border-radius: 4px;
              margin-right: 12px;
            }

            .contentTitleBox {
              width: 147px;
              font-size: 14px;
              color: #ffffff;
              line-height: 22px;
              margin-bottom: 12px;

              .contentTitle {
                word-break: break-all;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
                margin-bottom: 10px;
              }

              .timeItem {
                color: #999999;
                font-size: 12px;
              }
            }
          }
        }
      }
    }

    .NIM_wrap {
      width: 300px;
      height: 390px;

      .title {
        text-align: center;
        height: 44px;
        line-height: 44px;
        color: #27323f;
        font-size: 14px;
        background-color: #ffffff;
        border: 1px solid #eeeeee;
      }

      .information {
        height: 100%;
        background-color: #ffffff;
        overflow: auto;
        display: flex;
        flex-direction: column;

        .white {
          font-size: 13px;
          padding: 5px;

          .wrap {
            .formNick {
              color: #333333;
              line-height: 21px;
            }

            .text {
              border-radius: 8px;
              background-color: #4b4b4b;
              padding: 12px;
              max-width: 90%;
              display: inline-block;
              word-wrap: break-word;
            }
          }
        }
      }

      .barrageInput {
        background-color: #ffffff;
        display: flex;
        justify-content: space-around;
        align-items: center;

        .input {
          width: 78%;
        }

        .mt-10 {
          ::v-deep .icon-xiaolian {
            color: chocolate;
          }
        }
      }
    }

    .weizan {
      width: 90% !important;
      height: 90vh;
    }

    .weizans {
      width: 101% !important;
    }
  }

  .recommend {
    width: 1600px;
    margin: 0px calc(50% - 800px);
    height: 330px;
    border-radius: 8px;
    padding: 20px;
    background-color: #ffffff;
    margin: auto;

    .recommendText {
      height: 16px;
      font-size: 16px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      line-height: 16px;
      margin-bottom: 30px;
    }

    .itemBox {
      height: 318px;
      display: flex;
      overflow: hidden;

      .recommendItem {
        cursor: pointer;
        width: 240px;
        height: 197px;
        margin-right: 24px;

        .imgItem {
          width: 100%;
          height: 160px;
          border-radius: 4px 4px 4px 4px;
          margin-bottom: 12px;
        }

        .textItem {
          .courseName {
            font-size: 14px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            color: #333333;
            margin-bottom: 16px;
            line-height: 22px;
          }

          .playNum {
            display: flex;
            align-items: center;

            .symbol {
              width: 12px;
              height: 12px;
              margin-right: 4px;
            }

            .num {
              font-size: 12px;
              font-family: Microsoft YaHei-Bold, Microsoft YaHei;
              font-weight: bold;
              color: #999999;
              line-height: 12px;
            }
          }
        }
      }
    }
  }

  .tag {
    width: 52px;
    height: 20px;
    border-radius: 3px;
    padding: 0 8px;
    line-height: 20px;
    text-align: center;
    color: #ffffff;
    font-size: 12px;
    margin-right: 8px;
  }

  .tagBack {
    background: linear-gradient(136deg, #727a8a 0%, #494e59 100%);
  }

  .tagLive {
    background: linear-gradient(138deg, #ff9a51 0%, #ff5e51 100%);
  }

  .tagNot {
    background: linear-gradient(136deg, #727a8a 0%, #555555 100%);
  }
}

.dis-start {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.dis-end {
  display: flex;
  flex-direction: column;
  align-items: end;
}

.mainvideo {
  // width: calc(80% - 25px) !important;
  position: relative;
  height: 100%;
  display: flex;
}

.mainvideos {
  // width: calc(80% - 25px) !important;
  position: relative;
  height: 100%;
}

#J_prismPlayer {
  height: 100% !important;
}

#playbackPlayer {
  position: absolute;
  top: 0;
  left: 0;
  width: 200px;
}

#playbackPanel {
  position: relative;
  width: 100%;
  height: 675px;
}
</style>
